define('customPlugins/atnExpand',[
        'knockout', 'lodash', 'jquery', './utils'
    ],
    function(ko, _, $, utils) {
        'use strict';

        /**
         * Name of the attribute to which expand has to be set
         * @type {String}
         */
        var ATN_OPEN = 'atn-open';

        /**
         * Custombinding for the expand
         * @type {Object}
         */
        ko.bindingHandlers.atnExpand = {
            init: function(element, valueAccessor) {
                var value = valueAccessor(),
                    activeSubscription = value.subscribe(setActive);

                document.querySelector(utils.applicationRoot).addEventListener(
                    'click',
                    closeIfOpen
                );

                element.addEventListener('click', toggleIsOpen);

                if (element.querySelector('.dropdown-menu')) {
                    element.querySelector('.dropdown-menu').addEventListener(
                        'click',
                        function(e) {
                            var parentAttribute, selfAttribute;
                            if (e.target.parentElement && e.target.parentElement.attributes.getNamedItem('atn-role')) {
                                parentAttribute = e.target.parentElement.attributes.getNamedItem('atn-role').value;
                            }
                            if (e.target.attributes.getNamedItem('atn-role')) {
                                selfAttribute = e.target.attributes.getNamedItem('atn-role').value;
                            }
                            if (_.isString(parentAttribute) && _.isString(selfAttribute) &&
                                (selfAttribute.match('grid-action-anchor') || parentAttribute.match('grid-action-anchor'))) {
                                return true;
                            } else {
                                e.stopPropagation();
                            }
                        });
                }

                // disposal on removal of element
                ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                    activeSubscription.dispose();
                });

                /**
                 * function to toggle on/off state of expand
                 * If the element is disabled, then prevent its toggle behavior.
                 * @return {undefined}
                 */
                function toggleIsOpen() {
                    // The classname may be 'disabled', or something like 'dropdown disabled'.
                    if (element.className.length > 0) {
                        // confirm that one of the classes is 'disabled'.
                        var disabledElement = _.find(element.className.split(' '), function(name) {
                            return (name === 'disabled');
                        });
                        if (disabledElement === 'disabled') {
                            // If the element is disabled, then prevent its toggle behavior.
                            return false;
                        }
                    }

                    _.defer(function() {
                        value(!isActive());
                    });
                }

                /**
                 * function to close expand if it is already expanded
                 * @return {undefined}
                 */
                function closeIfOpen() {
                    if (isActive()) {
                        _.defer(function() {
                            value(false);
                        });
                    }
                }

                /**
                 * function to check if expand is in expanded state
                 * @return {Boolean}   if expand is in expanded state
                 */
                function isActive() {
                    return !!element.getAttribute(ATN_OPEN);
                }

                /**
                 * function to set the expand to a desired state
                 * true nmeans open, false means close
                 *
                 * @param {Boolean} value state to which expand has to be set
                 */
                function setActive(value) {
                    if (value) {
                        element.setAttribute(ATN_OPEN, true);
                    } else {
                        element.removeAttribute(ATN_OPEN);
                    }
                }
            }
        };


    });
